import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, Fragment } from "react";
import { yieldLazyLoad } from "../utils";
const Wrapper = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx(Fragment, {
        children: children
    });
};
/**
 * This component is similar to `yieldLazyLoad` but it allows to suspense any `Promise` within your
 * returned component tree.
 *
 * Example:
 *
 * ```ts
 * function MyComponent() {
 *      const myPromise = useMemo(() => Promise.resolve(), []);
 *
 *      return (<YieldLazyLoad promise={myPromise}>
 *          I get rendered when promise got resolved.
 *      </YieldLazyLoad>);
 * }
 * ```
 */ const YieldLazyLoad = (param)=>{
    let { promise, children, suspenseProbs } = param;
    const MyPromiseYielded = useMemo(()=>yieldLazyLoad((promise || Promise.resolve()).then(()=>Wrapper), undefined, suspenseProbs), [
        promise
    ]);
    return /*#__PURE__*/ _jsx(MyPromiseYielded, {
        children: children
    });
};
export { YieldLazyLoad };
